var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.476 25.229 c -0.034 -0.513 -0.058 -1.029 -0.058 -1.55 c 0 -12.714 10.307 -23.021 23.021 -23.021 c 9.198 0 17.133 5.396 20.82 13.193 c 2.777 -1.972 6.162 -3.142 9.827 -3.142 c 8.48 0 15.49 6.212 16.778 14.329 C 85.703 26.635 90 31.964 90 38.31 c 0 7.607 -6.167 13.774 -13.774 13.774 H 13.774 C 6.167 52.084 0 45.917 0 38.31 C 0 32.205 3.976 27.036 9.476 25.229 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(98,195,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.271 65.909 h 3.006 c 0.565 0 1.023 -0.457 1.023 -1.023 c 0 -0.565 -0.458 -1.023 -1.023 -1.023 h -3.005 l 1.503 -2.603 c 0.282 -0.489 0.114 -1.115 -0.375 -1.397 c -0.491 -0.284 -1.115 -0.114 -1.397 0.375 L 22.5 62.841 l -1.503 -2.603 c -0.283 -0.49 -0.908 -0.658 -1.397 -0.375 c -0.489 0.283 -0.657 0.908 -0.375 1.397 l 1.503 2.603 h -3.005 c -0.565 0 -1.023 0.457 -1.023 1.023 c 0 0.565 0.458 1.023 1.023 1.023 h 3.006 l -1.503 2.604 c -0.282 0.489 -0.114 1.115 0.375 1.397 c 0.161 0.093 0.337 0.137 0.51 0.137 c 0.354 0 0.697 -0.184 0.887 -0.511 l 1.503 -2.603 l 1.503 2.603 c 0.19 0.329 0.533 0.511 0.887 0.511 c 0.173 0 0.349 -0.044 0.51 -0.137 c 0.489 -0.283 0.657 -0.908 0.375 -1.397 L 24.271 65.909 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.504 77.159 h -3.005 l 1.503 -2.603 c 0.282 -0.489 0.114 -1.115 -0.375 -1.397 c -0.491 -0.284 -1.116 -0.114 -1.397 0.375 l -1.503 2.603 l -1.503 -2.603 c -0.283 -0.489 -0.908 -0.658 -1.397 -0.375 c -0.489 0.283 -0.657 0.908 -0.375 1.397 l 1.503 2.603 H 27.95 c -0.565 0 -1.023 0.457 -1.023 1.023 s 0.458 1.023 1.023 1.023 h 3.006 l -1.503 2.604 c -0.282 0.489 -0.114 1.115 0.375 1.397 c 0.161 0.093 0.337 0.137 0.51 0.137 c 0.354 0 0.697 -0.184 0.887 -0.511 l 1.503 -2.603 l 1.503 2.603 c 0.19 0.329 0.533 0.511 0.887 0.511 c 0.173 0 0.349 -0.044 0.51 -0.137 c 0.489 -0.283 0.657 -0.908 0.375 -1.397 l -1.503 -2.604 h 3.006 c 0.565 0 1.023 -0.457 1.023 -1.023 S 38.069 77.159 37.504 77.159 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.777 63.864 h -3.005 l 1.503 -2.603 c 0.283 -0.489 0.115 -1.115 -0.375 -1.397 c -0.488 -0.283 -1.115 -0.116 -1.397 0.375 L 45 62.841 l -1.503 -2.603 c -0.283 -0.49 -0.91 -0.658 -1.397 -0.375 c -0.489 0.283 -0.657 0.908 -0.375 1.397 l 1.503 2.603 h -3.005 c -0.565 0 -1.023 0.457 -1.023 1.023 c 0 0.565 0.458 1.023 1.023 1.023 h 3.006 l -1.503 2.604 c -0.282 0.489 -0.115 1.115 0.375 1.397 c 0.161 0.093 0.337 0.137 0.51 0.137 c 0.354 0 0.697 -0.183 0.887 -0.511 L 45 66.933 l 1.503 2.603 c 0.19 0.329 0.533 0.511 0.887 0.511 c 0.174 0 0.35 -0.044 0.51 -0.137 c 0.489 -0.283 0.657 -0.908 0.375 -1.397 l -1.503 -2.604 h 3.005 c 0.565 0 1.023 -0.457 1.023 -1.023 C 50.8 64.321 50.342 63.864 49.777 63.864 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.05 77.159 h -3.005 l 1.503 -2.603 c 0.283 -0.489 0.115 -1.115 -0.375 -1.397 c -0.488 -0.282 -1.115 -0.117 -1.397 0.375 l -1.503 2.603 l -1.503 -2.603 c -0.284 -0.491 -0.91 -0.656 -1.397 -0.375 c -0.489 0.283 -0.657 0.908 -0.375 1.397 l 1.503 2.603 h -3.005 c -0.565 0 -1.023 0.457 -1.023 1.023 s 0.457 1.023 1.023 1.023 h 3.006 l -1.503 2.604 c -0.283 0.489 -0.115 1.115 0.375 1.397 c 0.161 0.093 0.337 0.137 0.51 0.137 c 0.354 0 0.697 -0.183 0.887 -0.511 l 1.503 -2.603 l 1.503 2.603 c 0.19 0.329 0.533 0.511 0.887 0.511 c 0.174 0 0.35 -0.044 0.51 -0.137 c 0.489 -0.283 0.657 -0.908 0.375 -1.397 l -1.503 -2.604 h 3.006 c 0.565 0 1.023 -0.457 1.023 -1.023 S 62.615 77.159 62.05 77.159 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.277 63.864 h -3.005 l 1.503 -2.603 c 0.283 -0.489 0.115 -1.115 -0.375 -1.397 c -0.488 -0.283 -1.115 -0.116 -1.397 0.375 L 67.5 62.841 l -1.503 -2.603 c -0.283 -0.49 -0.91 -0.657 -1.397 -0.375 c -0.489 0.283 -0.657 0.908 -0.375 1.397 l 1.503 2.603 h -3.005 c -0.565 0 -1.023 0.457 -1.023 1.023 c 0 0.565 0.457 1.023 1.023 1.023 h 3.006 l -1.503 2.604 c -0.283 0.489 -0.115 1.115 0.375 1.397 c 0.161 0.093 0.337 0.137 0.51 0.137 c 0.354 0 0.697 -0.183 0.887 -0.511 l 1.503 -2.603 l 1.503 2.603 c 0.19 0.329 0.533 0.511 0.887 0.511 c 0.174 0 0.35 -0.044 0.51 -0.137 c 0.489 -0.283 0.657 -0.908 0.375 -1.397 l -1.503 -2.604 h 3.006 c 0.565 0 1.023 -0.457 1.023 -1.023 C 73.3 64.321 72.842 63.864 72.277 63.864 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.9e1f5c2bb0023d9fc20bfa3b9bfda80a.svg";
export { ForwardRef as ReactComponent };